var routes = {
  "/": "Home",
  "/blog": "Blog",
  "/appearances": "Appearances",
  "/projects": "Projects",
  "/about": "About"
};
module.exports = routes;